import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import StepForm from "../../../../Common/Components/StepForm";
import { useClassList } from "../Hooks";
import { useGetData } from "../Hooks/index";
function CreateClass() {
  const { formSubmit } = useClassList();
  const { GetData, data, loading } = useGetData();
  const { slug } = useParams();

  useEffect(() => {
    GetData();
  }, []);
  const form = {
    route: "/class/create_admin",
    titr: "ایجاد کلاس",
    firstStep: "step_1",
    lastStep: "step_5",
    lastBtn: "ایجاد کلاس",
    initialeState: {
      classmanager_id: slug,
      start_date: "2022/4/6",
      exp_register: "2022/12/3",
    },
    steps: [
      " مشخصات کلاس",
      "جزییات کلاس",
      "مدرسین",
      " تگ ها و سئو ",
      "زمان بندی کلاس ها",
    ],
    step_1: {
      title: " مشخصات کلاس",
      form: [
        {
          name: "نام",
          key: "name",
          type: "input",
          col: "col-md-4",
        },
        {
          name: "قیمت",
          key: "price",
          type: "input",
          col: "col-md-4",
        },
        {
          name: "رده بندی سنی",
          type: "select",
          col: "col-md-4",
          key: "agecatgegory",
          nested: "description",
          options: [
            {
              name: "کودکان",
              id: "child ",
            },
            {
              name: "نوجوانان",
              id: "teen",
            },
            {
              name: "جوانان",
              id: "young ",
            },
            {
              name: "بزرگسالان",
              id: "adults",
            },
          ],
        },
        {
          name: "استان شهرستان منطقه",
          type: "region",
          col: "col-md-12",
          key: "region_id",
        },
        {
          name: "توضیحات کلاس",
          key: "text",
          nested: "description",
          type: "editor",
          col: "col-md-12",
        },

        {
          name: "جنسیت",
          key: "gender",
          type: "select",
          col: "col-md-6",

          options: [
            {
              name: "آقایان",
              id: "men",
            },
            {
              name: "بانوان",
              id: "women",
            },
            {
              name: "هردو",
              id: "both",
            },
          ],
        },
        {
          name: "نحوه برگزاری کلاس",
          key: "type",
          type: "select",
          col: "col-md-6",
          options: [
            {
              name: "حضوری",
              id: "offline",
            },
            {
              name: "مجازی",
              id: "online",
            },
            {
              name: "هردو",
              id: "both",
            },
          ],
        },
        {
          name: "آدرس ( در صورت حضوری آدرس محل برگذاری در صورت آنلاین بودن لینک کلاس )",
          key: "adress",
          type: "input",
          col: "col-md-12",
          noNeed: true,
        },
      ],
    },
    step_2: {
      title: "جزییات",
      form: [
        {
          name: "ظرفیت",
          key: "capacity",
          type: "input",
          col: "col-md-6",
        },
        {
          name: "تعداد کل جلسات",
          key: "count_session",
          type: "input",
          col: "col-md-6",
        },
        {
          name: "آدرس دفتر برگزار کننده ",
          key: "address",
          type: "input",
          col: "col-md-6",
          nested: "organizer_details",
          noNeed: true,
        },
        {
          name: "لوکیشن دفتر برگزار کننده",
          key: "location",
          type: "input",
          col: "col-md-6",
          nested: "organizer_details",
          noNeed: true,
        },
        {
          name: "تلفن دفتر برگزرا کننده",
          key: "phone",
          type: "input",
          col: "col-md-6",
          nested: "organizer_details",
        },
        {
          name: "موبایل  ",
          key: "mobile",
          type: "input",
          col: "col-md-6",
          nested: "organizer_details",
        },
      ],
    },
    step_3: {
      title: "مدرسین",
      form: [
        {
          nested: "teachers",
          key: "teachers",
          type: "card",
          col: "col-12",
          forms: [
            { key: "name", name: "نام", type: "input" },
            { key: "cv", name: "رزرومه" },
            { key: "proof", name: "مدارک" },
            { key: "activity", name: "سابقه فعالیت" },
            { key: "details", name: "جزییات" },
            { key: "image", name: "image", type: "img" },
          ],
          noNeed: true,
        },
      ],
    },

    step_4: {
      title: " تگ ها و سئو  ",
      form: [
        {
          name: "کلمات کلیدی سئو",
          key: "seoKeyword",
          type: "textArea",
          col: "col-md-6",
          nested: "seo",
        },
        {
          name: "توضیحات کلیدی سئو",
          key: "seoDescription",
          type: "textArea",
          col: "col-md-6",
          nested: "seo",
        },
        {
          name: "تگ های کلاس",
          key: "tag_id",
          type: "selectTable",
          col: "col-md-6",
          options: !loading && data && data.Tags,
        },
        {
          name: "تصاویر",
          key: "images",

          col: "col-md-6",
          type: "file",

          accept: "image/png, image/jpeg",
        },
      ],
    },
    step_5: {
      title: "زمان بندی کلاس ها",
      form: [
        {
          name: "جدول زمانبندی",
          key: "details_session",
          nested: "details_session",
          type: "timeTable",
          col: "col-12",
        },
        {
          name: "تاریخ شروع",
          key: "start_date",
          type: "date",
          col: "col-md-6",
          noNeed: true,
        },
        {
          name: "مهلت ثبت نام",
          key: "exp_register",
          type: "date",
          col: "col-md-6",
          noNeed: true,
        },
      ],
    },
  };

  return <StepForm elements={form} />;
}

export default CreateClass;
